// 国家代码枚举
export enum CountryCode {
	CN = 'CN', // 中国
	US = 'US', // 美国
	IN = 'IN', // 印度
	JP = 'JP', // 日本
	GB = 'GB', // 英国
	DE = 'DE', // 德国
	FR = 'FR', // 法国
	IT = 'IT', // 意大利
	ES = 'ES', // 西班牙
	ID = 'ID', // 印尼
	BR = 'BR', // 巴西
	MX = 'MX', // 墨西哥
	RU = 'RU', // 俄罗斯
	SA = 'SA', // 沙特阿拉伯
	TH = 'TH', // 泰国
	VN = 'VN', // 越南
	MY = 'MY', // 马来西亚
	AR = 'AR', // 阿根廷
	PH = 'PH', // 菲律宾
	NONE = '', // 无国家代码
	// ... 其他需要的国家代码
}

// 工具类
export class CountryUtils {
	// 获取当前用户的国家代码
	static get currentCountryCode(): CountryCode {
		// 从 localStorage 或 API 获取
		let countryCode = localStorage.getItem('user_country') as CountryCode;
		if (!countryCode) {
			countryCode = window.AndroidInterface?.getUserCountry?.() as CountryCode;
			countryCode && localStorage.setItem('user_country', countryCode);
		}
		return countryCode || CountryCode.NONE;
	}

	// 开斋节国家范围
	private static readonly LASSER_BAIRAM_COUNTRIES: CountryCode[] = [CountryCode.ID, CountryCode.MY];

	// 复活节国家范围
	private static readonly EASTER_COUNTRIES: CountryCode[] = [
		CountryCode.BR,
		CountryCode.MX,
		CountryCode.AR,
		CountryCode.US,
		CountryCode.GB,
		CountryCode.DE,
		CountryCode.FR,
		CountryCode.PH,
	];

	// 付费挽留弹窗覆盖国家范围
	private static readonly PAY_RETAIN_COUNTRIES: CountryCode[] = [CountryCode.IN, CountryCode.ID];

	// 获取当前国家是否在开斋节国家范围内
	static get isLasserBairam(): boolean {
		return false;
	}

	// 获取当前国家是否在复活节国家范围内
	static get isEaster(): boolean {
		return false;
	}

	// 获取当前国家是否在付费挽留弹窗覆盖范围内
	static get isPayRetain(): boolean {
		return this.PAY_RETAIN_COUNTRIES.includes(this.currentCountryCode);
	}

	// 获取当前国家是否在取消订阅挽留测试覆盖范围内
	static get isCancelSubscribeRetain(): boolean {
		return this.currentCountryCode === CountryCode.ID;
	}

	static get isIndiaCountry(): boolean {
		return this.currentCountryCode === CountryCode.IN;
	}

}
